import Validation from "utils/validation.utils";
import locale from "localization";
const initialState = (expense) => {
  return {
    shiftId: {
      name: "shiftId",
      value: expense?.shift?.shiftId,
      label: locale.selectShift,
      placeholder: locale.selectShift,
      required: true,
      validations: [Validation.required()],
      disableAllOption: true,
    },
    type: {
      name: "type",
      value: expense?.type || "",
      variant: "purple",
      label: locale.depositType,
      placeholder: locale.selectExpenseType,
      required: true,
      validations: [Validation.required()],
    },
    amount: {
      name: "amount",
      value: expense?.amount || "",
      label: locale.amount,
      required: true,
      isPriceValue: true,
      innerLabel: true,
      min: 1,
      max: 999999999999.99,
      placeholder: "0.00",
      validations: [Validation.required(), Validation.min(1)],
    },
    rebateType: {
      name: "rebateType",
      value: expense?.rebateType || "",
      variant: "purple",
      label: locale.rebateType,
      placeholder: locale.selectRebateType,
      required: false,
    },
    referenceNumber: {
      name: "referenceNumber",
      value: expense?.referenceNumber || "",
      label: locale.referenceNumber,
      innerLabel: true,
      minlength: 1,
      maxLength: 75,
      placeholder: "",
      required: false,
      validations: [Validation.minlength(1), Validation.maxlength(15)],
    },
    slip: {
      name: "slip",
      value: expense?.imageUrl || null,
      type: "image",
      text: locale.uploadImage,
      validatedDimension: false,
      buttonProps: {
        style: {
          backgroundColor: "transparent",
          color: "#5349b7",
          borderColor: "#5349b7",
          fontWeight: "500",
        },
        variant: "outlined",
      },
    },
    remarks: {
      name: "remarks",
      value: expense?.remarks || "",
      label: locale.remarks,
      placeholder: locale.sampleRemarks,
      maxLength: 500,
    },
  };
};

export default initialState;
